import Icon from '../components/Icon.vue'

Icon.register({
  palette: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M204.3 5c163.8-31.9 307.2 92.1 307.7 249.7-0.1 35.7-29.1 65.3-64.9 65.3h-79.7c-51 0-84 53-60.9 98.4 18.9 37.1-1.3 85.3-42.5 91.7-127.1 19.7-295.8-119.7-258.8-306.7 19.6-99.1 99.7-179 199.1-198.4zM96 320c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM128 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM256 128c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM384 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/palette.js
// module id = 1606
// module chunks = 0